const domain: string = window.location.origin;

export const getApplicationDomain = (): string => domain;
